import { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Loader,
  Table,
  Center,
  Text,
  Paper,
  Group,
  ActionIcon,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { getTenantApikeys, deleteApiKey } from "../api";
import { IconTrash } from "@tabler/icons-react";
import { ApiKeyCreateForm } from "./ApiKeyCreate";
import { notifications } from "@mantine/notifications";

export default function ApiKeys() {
  const [apiKeys, setApiKeys] = useState(null);
  const [opened, { open, close }] = useDisclosure(false);

  useEffect(() => {
    getTenantApikeys().then((data) => {
      setApiKeys(data);
    });
  }, []);

  return (
    <Paper mt="md">
      <Modal
        size="lg"
        closeOnClickOutside={false}
        opened={opened}
        p="xl"
        onClose={close}
        title="API Key"
      >
        <ApiKeyCreateForm keyAdded={(newKey) => { setApiKeys([newKey, ...apiKeys])}} />
      </Modal>

      <Group justify="space-between">
        <Text mb="sm" fz="xl" fw={500}>
          API Keys
        </Text>

        <Button variant="outline" onClick={() => open()}>Create new key</Button>
      </Group>

      {!apiKeys ? (
        <Center>
          <Loader size="xl" mt="xl" />
        </Center>
      ) : (
        <Table stickyHeader stickyHeaderOffset={60}>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Id</Table.Th>
              <Table.Th>Name</Table.Th>
              <Table.Th>Last 4</Table.Th>
              <Table.Th>Created</Table.Th>
              <Table.Th>Last Used</Table.Th>
              {/* <Table.Th>User</Table.Th> */}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {apiKeys.map((p) => (
              <Table.Tr key={p.id}>
                <Table.Td>{p.id}</Table.Td>
                <Table.Td>{p.name}</Table.Td>
                <Table.Td>{p.last4}</Table.Td>
                <Table.Td>{p.created}</Table.Td>
                <Table.Td>{p.lastUsed}</Table.Td>
                {/* <Table.Td>{p.userId}</Table.Td> */}
                <Table.Td>
                  <ActionIcon
                    color="red"
                    variant="outline"
                    onClick={() => deleteApiKey(p.id).then(() => {
                      setApiKeys(apiKeys.filter(q => q.id != p.id));
                      notifications.show({ title: 'API key deleted' });
                    })}
                  >
                    <IconTrash size="1rem" />
                  </ActionIcon>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      )}
    </Paper>
  );
}
